import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import fanyiPic from '@/assets/fanyi.png';
import { getBrandList, addBrand, getBrandDetail, updateBrandInfo, updateBrandStatus, deleteBrand } from '@/services/product/brand';
export default {
  name: 'brandList',
  i18n: require('./i18n-brand'),
  data: function data() {
    var _this = this;
    var self = this;
    var validateFirstLetter0 = function validateFirstLetter0(rule, value, callback) {
      var brand = _this.fromData.multilingualList[0];
      if (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateFirstLetter1 = function validateFirstLetter1(rule, value, callback) {
      var brand = _this.fromData.multilingualList[1];
      if (brand.name && (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0)) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateFirstLetter2 = function validateFirstLetter2(rule, value, callback) {
      var brand = _this.fromData.multilingualList[2];
      if (brand.name && (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0)) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateBrandName0 = function validateBrandName0(rule, value, callback) {
      var brand = _this.fromData.multilingualList[0];
      if (!brand.name) {
        callback(new Error(_this.$t('brandList.enterBrandNamePlease')));
      } else {
        callback();
      }
    };
    var validateBrandName1 = function validateBrandName1(rule, value, callback) {
      _this.$refs.addModal.validateField('firstLetter1');
      callback();
    };
    var validateBrandName2 = function validateBrandName2(rule, value, callback) {
      _this.$refs.addModal.validateField('firstLetter2');
      callback();
    };
    var validateFirstLetterForEdite0 = function validateFirstLetterForEdite0(rule, value, callback) {
      var brand = _this.fromDataForEdit.multilingualList[0];
      if (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateFirstLetterForEdite1 = function validateFirstLetterForEdite1(rule, value, callback) {
      var brand = _this.fromDataForEdit.multilingualList[1];
      if (!brand.name) {
        brand.firstLetters = [];
      }
      if (brand.name && (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0)) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateFirstLetterForEdite2 = function validateFirstLetterForEdite2(rule, value, callback) {
      var brand = _this.fromDataForEdit.multilingualList[2];
      if (!brand.name) {
        brand.firstLetters = [];
      }
      if (brand.name && (!brand.firstLetters || brand.firstLetters && brand.firstLetters.length == 0)) {
        callback(new Error(_this.$t('brandList.enterChooseBrandFirstLetter')));
      } else {
        callback();
      }
    };
    var validateBrandNameForEdite0 = function validateBrandNameForEdite0(rule, value, callback) {
      var brand = _this.fromDataForEdit.multilingualList[0];
      if (!brand.name) {
        callback(new Error(_this.$t('brandList.enterBrandNamePlease')));
      } else {
        callback();
      }
    };
    var validateBrandNameForEdite1 = function validateBrandNameForEdite1(rule, value, callback) {
      _this.$refs.editModal.validateField('firstLetter1');
      callback();
    };
    var validateBrandNameForEdite2 = function validateBrandNameForEdite2(rule, value, callback) {
      _this.$refs.editModal.validateField('firstLetter2');
      callback();
    };
    return {
      creatLoading: false,
      editLoading: false,
      listTotal: 0,
      defaultLangObj: {},
      listQuery: {
        brandStatus: undefined,
        brandName: ''
      },
      //搜索条件
      queryParam: {
        page: 1,
        size: 20,
        brandStatus: undefined,
        brandName: '',
        orderType: 3,
        orderWay: 1
      },
      brandLangList: [],
      fanyiPic: fanyiPic,
      brandList: [],
      isTableLoading: false,
      nameErr: this.$t('brandList.enterBrandNamePlease'),
      tableLoading: false,
      imageUrl: '',
      loading: false,
      fromData: {
        //新增品牌
        multilingualList: []
        // initialsList: [],
      },
      fromDataForEdit: {
        //编辑品牌
        id: '',
        multilingualList: []
      },
      addMondalVisible: false,
      editModal: false,
      rules: {
        brandName0: [{
          required: true,
          validator: validateBrandName0,
          trigger: 'blur'
        }],
        brandName1: [{
          validator: validateBrandName1,
          trigger: 'blur'
        }],
        brandName2: [{
          validator: validateBrandName2,
          trigger: 'blur'
        }],
        firstLetter1: [{
          validator: validateFirstLetter1,
          trigger: 'blur'
        }],
        firstLetter2: [{
          validator: validateFirstLetter2,
          trigger: 'blur'
        }],
        firstLetter0: [{
          required: true,
          validator: validateFirstLetter0,
          trigger: 'blur'
        }]
        // firstLetter0: [{
        // 	type: 'array',
        // 	required: true,
        // 	message: this.$t('brandList.enterChooseBrandFirstLetter'),
        // 	trigger: 'blur'
        // }]
      },
      rulesForEdite: {
        brandName0: [{
          required: true,
          validator: validateBrandNameForEdite0,
          trigger: 'blur'
        }],
        brandName1: [{
          validator: validateBrandNameForEdite1,
          trigger: 'blur'
        }],
        brandName2: [{
          validator: validateBrandNameForEdite2,
          trigger: 'blur'
        }],
        firstLetter1: [{
          validator: validateFirstLetterForEdite1,
          trigger: 'blur'
        }],
        firstLetter2: [{
          validator: validateFirstLetterForEdite2,
          trigger: 'blur'
        }],
        firstLetter0: [{
          required: true,
          validator: validateFirstLetterForEdite0,
          trigger: 'blur'
        }]
        // brandName0: [{
        // 	required: true,
        // 	message:  this.$t('brandList.enterBrandNamePlease'),
        // 	trigger: 'blur'
        // }]
      },
      sortedInfo: {
        columnKey: "updateTime",
        field: "updateTime",
        order: "descend"
      }
    };
  },
  computed: {
    name1: function name1() {
      if (this.fromData.multilingualList[1]) {
        return this.fromData.multilingualList[1].name;
      }
    },
    name2: function name2() {
      if (this.fromData.multilingualList[2]) {
        return this.fromData.multilingualList[2].name;
      }
    },
    nameForEdite1: function nameForEdite1() {
      if (this.fromDataForEdit.multilingualList[1]) {
        return this.fromDataForEdit.multilingualList[1].name;
      }
    },
    nameForEdite2: function nameForEdite2() {
      if (this.fromDataForEdit.multilingualList[2]) {
        return this.fromDataForEdit.multilingualList[2].name;
      }
    }
  },
  watch: {
    name1: function name1(newValue) {
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.fromData.multilingualList[1].firstLetters = [];
        if (this.$refs.addModal) {
          this.$refs.addModal.validateField('firstLetter1');
        }
      }
    },
    name2: function name2(newValue) {
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.fromData.multilingualList[2].firstLetters = [];
        if (this.$refs.addModal) {
          this.$refs.addModal.validateField('firstLetter2');
        }
      }
    },
    nameForEdite1: function nameForEdite1(newValue) {
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.fromDataForEdit.multilingualList[1].firstLetters = [];
        if (this.$refs.editModal) {
          this.$refs.editModal.validateField('firstLetter1');
        }
      }
    },
    nameForEdite2: function nameForEdite2(newValue) {
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.fromDataForEdit.multilingualList[2].firstLetters = [];
        if (this.$refs.editModal) {
          this.$refs.editModal.validateField('firstLetter2');
        }
      }
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getInitialValue();
  },
  methods: {
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('brandList.brandName') + '(' + item.langName + ')';
          nameObj.firstLetterName = self.$t('brandList.firstLetter') + '(' + item.langName + ')';
          nameObj.titleComment = self.$t('brandList.brandComment') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //品牌名称
          nameObj.name = "";
          //品牌描述
          nameObj.content = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          nameObj.showCommentFY = false;
          nameObj.firstLetters = [];
          self.brandLangList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.fromData.multilingualList = _.cloneDeep(self.brandLangList);
    },
    getQueryList: function getQueryList() {
      var _this2 = this;
      this.queryParam.brandName = this.listQuery.brandName;
      this.queryParam.brandStatus = this.listQuery.brandStatus;
      this.queryParam.page = 1;
      this.tableLoading = true;
      this.isTableLoading = true;
      getBrandList(this.queryParam).then(function (response) {
        _this2.tableLoading = false;
        _this2.brandList = response.data.data.list;
        _this2.listTotal = response.data.data.total;
      }).finally(function () {
        _this2.isTableLoading = false;
      });
    },
    /* 获取列表功能 */getList: function getList() {
      var _this3 = this;
      this.isTableLoading = true;
      getBrandList(this.queryParam).then(function (response) {
        _this3.brandList = response.data.data.list;
        _this3.listTotal = response.data.data.total;
      }).finally(function () {
        _this3.isTableLoading = false;
      });
    },
    showFYBtnOfTextareaForEdit: function showFYBtnOfTextareaForEdit(brandCommentObj) {
      var self = this;
      var brandCommentListClone = self.fromDataForEdit.multilingualList;
      var _iterator2 = _createForOfIteratorHelper(brandCommentListClone),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var one = _step2.value;
          one.showCommentFY = false;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      self.fromDataForEdit.multilingualList = brandCommentListClone;
      brandCommentObj.showCommentFY = true;
    },
    showFYBtnForEdit: function showFYBtnForEdit(brandNameObj) {
      var self = this;
      var brandNameListClone = self.fromDataForEdit.multilingualList;
      var _iterator3 = _createForOfIteratorHelper(brandNameListClone),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var one = _step3.value;
          one.showNameFY = false;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      self.fromDataForEdit.multilingualList = brandNameListClone;
      brandNameObj.showNameFY = true;
    },
    showFYBtnOfTextarea: function showFYBtnOfTextarea(brandCommentObj) {
      var self = this;
      var brandCommentListClone = self.fromData.multilingualList;
      var _iterator4 = _createForOfIteratorHelper(brandCommentListClone),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var one = _step4.value;
          one.showCommentFY = false;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      self.fromData.multilingualList = brandCommentListClone;
      brandCommentObj.showCommentFY = true;
    },
    showFYBtn: function showFYBtn(brandNameObj) {
      var self = this;
      var brandNameListClone = self.fromData.multilingualList;
      var _iterator5 = _createForOfIteratorHelper(brandNameListClone),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var one = _step5.value;
          one.showNameFY = false;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      self.fromData.multilingualList = brandNameListClone;
      brandNameObj.showNameFY = true;
    },
    addBrand: function addBrand() {
      var _this4 = this;
      this.addMondalVisible = true;
      this.creatLoading = false;
      this.resetFields();
      this.$nextTick(function () {
        _this4.$refs.addModal.resetFields();
      });
    },
    resetFields: function resetFields() {
      // this.fromData.initialsList = undefined,
      this.fromData.multilingualList = _.cloneDeep(this.brandLangList);
    },
    editBrand: function editBrand(record) {
      var self = this;
      getBrandDetail(record.id).then(function (response) {
        if (response.data.code == 200) {
          console.log(response.data);
          self.fromDataForEdit.id = response.data.data.id;
          // this.fromDataForEdit.initialsList = response.data.data.initialsList;
          var dataList = response.data.data.multilingualList;
          var langList = _.cloneDeep(self.brandLangList);
          var _iterator6 = _createForOfIteratorHelper(langList),
            _step6;
          try {
            var _loop = function _loop() {
              var langObj = _step6.value;
              var findObj = _.find(dataList, function (o) {
                return o.langId == langObj.langId;
              });
              if (findObj) {
                langObj.id = findObj.id;
                langObj.name = findObj.name;
                langObj.content = findObj.content;
                langObj.firstLetters = findObj.firstLetters;
              }
            };
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          self.fromDataForEdit.multilingualList = _.cloneDeep(langList);
          self.editModal = true;
          self.$nextTick(function () {
            self.$refs.editModal.resetFields();
          });
          self.editLoading = false;
        }
      });
    },
    editSubmit: function editSubmit() {
      var _this5 = this;
      this.editLoading = true;
      this.$refs.editModal.validate(function (valid) {
        if (valid) {
          updateBrandInfo(_this5.fromDataForEdit).then(function (response) {
            if (response.data.code == 200) {
              _this5.$message.success(_this5.$t('public.updateSuccessfully'));
              _this5.editModal = false;
              _this5.getList();
            } else {
              _this5.editLoading = false;
            }
          }).finally(function () {
            _this5.editLoading = false;
          });
        } else {
          _this5.editLoading = false;
          return false;
        }
      });
    },
    addSubmit: function addSubmit() {
      var _this6 = this;
      this.creatLoading = true;
      this.$refs.addModal.validate(function (valid) {
        if (valid) {
          _this6.fromData.allowCloseReqLoading = false;
          addBrand(_this6.fromData).then(function (response) {
            if (response.data.code == 200) {
              _this6.$message.success(_this6.$t('brandList.insertok'));
              _this6.addMondalVisible = false;
              _this6.getList();
            } else {
              _this6.creatLoading = false;
            }
          }).finally(function () {
            _this6.creatLoading = false;
          });
        } else {
          _this6.creatLoading = false;
          return false;
        }
      });
    },
    changStatus: function changStatus(brand) {
      var _this7 = this;
      var self = this;
      var status = brand.brandStatus == 1 ? 0 : 1;
      var statusObj = {
        id: brand.id,
        status: status
      };
      if (typeof brand.updateBrandStatusLoading === 'undefined') {
        this.$set(brand, 'updateBrandStatusLoading', false);
      }
      if (brand.updateBrandStatusLoading) return;
      brand.updateBrandStatusLoading = true;
      updateBrandStatus(statusObj).then(function (response) {
        if (response.data.code == 200) {
          _this7.$message.success(_this7.$t('public.updateSuccessfully'));
          _this7.getList();
        }
      }).finally(function () {
        brand.updateBrandStatusLoading = false;
      });
    },
    confirm: function confirm(id) {
      var _this8 = this;
      var self = this;
      deleteBrand(id).then(function (response) {
        if (response.data.code == 200) {
          _this8.$message.success(_this8.$t('public.deleteSuccessfully'));
          _this8.getList();
        }
      });
    },
    cancel: function cancel(e) {},
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.sortedInfo = sorter;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        var order = sorter.order || "descend";
        var orders = order === "descend" ? 1 : 2;

        // this.$refs.brandList.$children[0].sSortOrder = sorter.order
        if (sorter.columnKey == "productNumber") {
          this.queryParam.orderType = 1;
        } else if (sorter.columnKey == "brandStatus") {
          this.queryParam.orderType = 2;
        } else {
          this.queryParam.orderType = 3;
        }
        this.queryParam.orderWay = orders;
      }
      this.getList();
    }
  }
};